import type { ToolDefinition } from '../../lib/api';
import { HttpToolTestPanel } from './HttpToolTestPanel';
import { LookupToolTestPanel } from './LookupToolTestPanel';

interface ToolTestPanelProps {
  tool: ToolDefinition;
  onSourceResponse?: (response: unknown) => void;
}

export const ToolTestPanel = ({ tool, onSourceResponse }: ToolTestPanelProps) =>
  tool.execution_kind === 'schema_lookup' ? (
    <LookupToolTestPanel tool={tool} />
  ) : (
    <HttpToolTestPanel tool={tool} onSourceResponse={onSourceResponse} />
  );
